import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78b1fc8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-cy"]
const _hoisted_2 = {
  key: 0,
  class: "tw-mr-[3px]"
}

import store from "@/store";
import {
  checklistRequestedStatusId,
  checklistStatusId,
  statusCode,
} from "@/utils/constants";
import utilities from "@/utils/utilities";
import { computed, onMounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'statusBadge',
  props: {
  value: { type: String, required: true },
  isCursorPointer: { type: Boolean, default: false, required: false },
  statusNumber: { type: Number, default: () => 0 },
  label: { type: String, default: () => null },
  lableClass: { type: String, default: () => "" },
  dataCy: { type: String, default: () => "" },
  isCheckPlan: { type: Boolean, default: false },
  classCurrentUser: { type: String, default: "" },
},
  emits: ["update:status"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "dec496ee": (borderColor.value),
  "eec58a56": (color.value)
}))


const color = computed(() => (props.isCheckPlan ? "#904bd6" : "#878787"));
const borderColor = computed(() => (props.isCheckPlan ? "#eee4f9" : "#eff0f1"));
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);


const updateStatus = (value) =>
  value == statusCode.pending ||
  (checklistStatusId.created && emit("update:status", value));
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const status = reactive({});

onMounted(() => {
  switch (props.value) {
    case statusCode.active:
      status[statusCode.active] = {
        label: getUiText("app-component-table-cell-status-active-1"),
        className: "active",
      };
      break;
    case statusCode.invited:
      status[statusCode.invited] = {
        label: getUiText("app-component-table-cell-status-invited-1"),
        className: "invited",
      };
      break;
    case statusCode.deactivated:
      status[statusCode.deactivated] = {
        label: getUiText("app-component-table-cell-status-deactivated-1"),
        className: "deactivated",
      };
      break;
    case statusCode.pending:
      status[statusCode.pending] = {
        label: getUiText("app-component-table-cell-status-pending-1"),
        className: "pending",
      };
      break;
    case statusCode.critical:
      status[statusCode.critical] = {
        label: getUiText(
          "app-component-assessments-checklists-exposures-card-2",
        ),
        className: "critical",
      };
      break;
    case statusCode.high:
      status[statusCode.high] = {
        label: getUiText(
          "app-assess-recommendations-action-table-status-high-1",
        ),
        className: "high",
      };
      break;
    case statusCode.highest:
      status[statusCode.highest] = {
        label: getUiText(
          "app-assess-recommendations-action-table-status-highest-1",
        ),
        className: "significant",
      };
      break;
    case statusCode.moderate:
      status[statusCode.moderate] = {
        label: getUiText(
          "app-assess-recommendations-action-table-status-moderate-1",
        ),
        className: "moderate",
      };
      break;
    case statusCode.suggested:
      status[statusCode.suggested] = {
        label: getUiText(
          "app-assess-recommendations-action-table-status-suggested-1",
        ),
        className: "suggested",
      };
      break;
    case statusCode.applied:
      status[statusCode.applied] = {
        label: getUiText(
          "app-assess-recommendations-action-table-status-applied-1",
        ),
        className: "applied",
      };
      break;
    case statusCode.category:
      status[statusCode.category] = {
        label: "",
        className: "category",
      };
      break;
    case statusCode.subCategory:
      status[statusCode.subCategory] = {
        label: "",
        className: "subCategory",
      };
      break;
    case statusCode.locked:
      status[statusCode.locked] = {
        label: getUiText("app-component-table-cell-status-locked-1"),
        className: "critical",
      };
      break;
    case statusCode.verify:
      status[statusCode.verify] = {
        label: getUiText("app-component-table-cell-status-verified-1"),
        className: "active",
      };
      break;
    case statusCode.pendingVerify:
      status[statusCode.pendingVerify] = {
        label: getUiText("app-component-table-cell-status-pending-creation-1"),
        className: "pending",
      };
      break;
    case statusCode.notVerify:
      status[statusCode.notVerify] = {
        label: getUiText("app-component-table-cell-status-not-verified-1"),
        className: "deactivated",
      };
      break;
    case statusCode.archived:
      status[statusCode.archived] = {
        label: getUiText("app-component-table-cell-status-archived-1"),
        className: "deactivated",
      };
      break;
    case statusCode.disable:
      status[statusCode.disable] = {
        label: "",
        className: "disable",
      };
      break;
    case statusCode.system:
      status[statusCode.system] = {
        label: "",
        className: "System",
      };
      break;
    case statusCode.org:
      status[statusCode.org] = {
        label: "",
        className: "Org",
      };
      break;
    case statusCode.parent:
      status[statusCode.parent] = {
        label: "",
        className: "Parent",
      };
      break;
    case statusCode.required:
      status[statusCode.required] = {
        label: getUiText(
          "app-component-assessments-assessment-question-evidence-required-tag-1",
        ),
        className: "required",
      };
      break;
    case statusCode.accepted:
      status[statusCode.accepted] = {
        label: getUiText("app-component-status-badge-code-accepted-1"),
        className: "accepted",
      };
      break;
    case statusCode.informationRequired:
      status[statusCode.informationRequired] = {
        label: getUiText(
          "app-component-status-badge-code-information-required-1",
        ),
        className: "information-required",
      };
      break;
    case statusCode.notAccepted:
      status[statusCode.notAccepted] = {
        label: getUiText("app-component-status-badge-code-not-accepted-1"),
        className: "not-accepted",
      };
      break;
    case statusCode.inProgress:
      status[statusCode.inProgress] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-1",
        ),
        className: "inProgress",
      };
      break;
    case statusCode.notStarted:
      status[statusCode.notStarted] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-5",
        ),
        className: "notStarted",
      };
      break;
    case statusCode.complete:
      status[statusCode.complete] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-3",
        ),
        className: "complete",
      };
      break;
    case statusCode.created:
      status[statusCode.created] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-label-1",
        ),
        className: "notStarted",
      };
      break;
    case statusCode.completed:
      status[statusCode.completed] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-3",
        ),
        className: "completed",
      };
      break;
    case statusCode.waitingOnUs:
      status[statusCode.waitingOnUs] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-5",
        ),
        className: "onHold",
      };
      break;
    case statusCode.waiting:
      status[statusCode.waiting] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-5",
        ),
        className: "onHold",
      };
      break;
    case statusCode.paused:
      status[statusCode.paused] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-5",
        ),
        className: "onHold",
      };
      break;
    case statusCode.other:
      status[statusCode.other] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-5",
        ),
        className: "onHold",
      };
      break;
    case statusCode.audited:
      status[statusCode.audited] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-4",
        ),
        className: "audited",
      };
      break;
    case statusCode.defunct:
      status[statusCode.defunct] = {
        label: getUiText(
          "app-component-assessments-checklists-assessment-details-card-status-3",
        ),
        className: "defunct",
      };
      break;
    case statusCode.vendorSubmitted:
      status[statusCode.vendorSubmitted] = {
        label: getUiText(
          "app-component-status-badge-vendor-assessment-submitted-status-1",
        ),
        className: "vendorSubmitted",
      };
      break;
    case statusCode.waitingForVendor:
      status[statusCode.waitingForVendor] = {
        label: getUiText(
          "app-component-status-badge-vendor-assessment-waiting-status-1",
        ),
        className: "waitingForVendor",
      };
      break;
    case statusCode.wait:
      status[statusCode.wait] = {
        label: getUiText(
          "app-component-status-badge-vendor-assessment-wait-status-1",
        ),
        className: "wait",
      };
      break;
    case statusCode.inProg:
      status[statusCode.inProg] = {
        label: getUiText(
          "app-component-status-badge-vendor-assessment-in-progress-status-1",
        ),
        className: "inProgress",
      };
      break;
    case checklistRequestedStatusId.created:
      status[checklistRequestedStatusId.created] = {
        label: getUiText(
          "app-component-assessments-checklists-requested-status-created-1",
        ),
        className: "checkListRequestedCreated",
      };
      break;
    case checklistStatusId.inProgress:
      status[checklistStatusId.inProgress] = {
        label: getUiText(
          "app-component-assessments-checklist-requested-status-inprogress-1",
        ),
        className: "checkListRequestedInprogress",
      };
      break;
    case checklistStatusId.waiting:
      status[checklistStatusId.waiting] = {
        label: getUiText(
          "app-component-assessments-checklist-requested-status-waiting-1",
        ),
        className: "checkListRequestedWait",
      };
      break;
    case checklistStatusId.submitted:
      status[checklistStatusId.submitted] = {
        label: getUiText(
          "app-component-status-badge-vendor-assessment-submitted-status-1",
        ),
        className: "checkListRequestedSubmited",
      };
      break;
    case checklistStatusId.completed:
      status[checklistStatusId.completed] = {
        label: getUiText(
          "app-component-assessments-checklists-requested-status-completed-1",
        ),
        className: "checkListRequestedCompleted",
      };
      break;
    default:
      break;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-items-center tw-inline-flex", `${
      __props.isCursorPointer ? 'tw-w-[180px] tw-cursor-pointer' : 'tw-w-[180px]'
    }`])
  }, [
    (__props.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([`${status[__props.value]?.className} ${__props.classCurrentUser}`, "cell-status tw-flex tw-items-center"]),
          "data-cy": __props.dataCy,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateStatus(__props.value)))
        }, [
          (__props.statusNumber)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.statusNumber), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(`tw-max-w-[115px] tw-truncate ${__props.lableClass}`),
            "data-cy": "status-badge-lable"
          }, _toDisplayString(__props.label ?? status[__props.value]?.label), 3)
        ], 10, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})